export default __webpack_public_path__ + "static/media/capa.7a9d7297.gif";